// Regra única das telas do Workflow SOX: usuário bloqueado não é oferecido em listas de seleção
// (responsável, titular, substituto, acessos…), nem aparece numa busca por nome. O backend também
// recusa novas atribuições a bloqueados — aqui é só para não oferecer a opção.

/**
 * Remove os bloqueados das opções de seleção.
 * @param manter ids já gravados no campo: continuam na lista mesmo se bloqueados depois, para o
 *   valor atual não ficar em branco/inconsistente na tela (não é uma nova atribuição).
 */
export const usuariosSelecionaveis = <T extends { id: number; bloqueado?: boolean }>(
  usuarios: T[],
  manter: (number | '' | null | undefined)[] = [],
): T[] => usuarios.filter(u => !u.bloqueado || manter.includes(u.id));

/** Busca por nome/e-mail já considerando a regra de bloqueio. */
export const buscarUsuariosSelecionaveis = <T extends { id: number; nome: string; email?: string; bloqueado?: boolean }>(
  usuarios: T[],
  termo: string,
): T[] => {
  const q = termo.trim().toLowerCase();
  return usuariosSelecionaveis(usuarios).filter(u =>
    !q || u.nome.toLowerCase().includes(q) || (u.email ?? '').toLowerCase().includes(q));
};
